/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ greeting: NonNullable<unknown>, name: NonNullable<unknown> }} Today_Greeting_NamedInputs */

const en_us2_today_greeting_named = /** @type {(inputs: Today_Greeting_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.greeting}, ${i?.name}`)
};

const pt_br2_today_greeting_named = /** @type {(inputs: Today_Greeting_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.greeting}, ${i?.name}`)
};

const es_419_today_greeting_named = /** @type {(inputs: Today_Greeting_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.greeting}, ${i?.name}`)
};

const pt_pt2_today_greeting_named = /** @type {(inputs: Today_Greeting_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.greeting}, ${i?.name}`)
};

const fr_fr2_today_greeting_named = /** @type {(inputs: Today_Greeting_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.greeting}, ${i?.name}`)
};

const de_de2_today_greeting_named = /** @type {(inputs: Today_Greeting_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.greeting}, ${i?.name}`)
};

const it_it2_today_greeting_named = /** @type {(inputs: Today_Greeting_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.greeting}, ${i?.name}`)
};

/**
* | output |
* | --- |
* | "{greeting}, {name}" |
*
* @param {Today_Greeting_NamedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_greeting_named = /** @type {((inputs: Today_Greeting_NamedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Greeting_NamedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_greeting_named(inputs)
	if (locale === "es-419") return es_419_today_greeting_named(inputs)
	if (locale === "pt-PT") return pt_pt2_today_greeting_named(inputs)
	if (locale === "fr-FR") return fr_fr2_today_greeting_named(inputs)
	if (locale === "de-DE") return de_de2_today_greeting_named(inputs)
	if (locale === "it-IT") return it_it2_today_greeting_named(inputs)
	return en_us2_today_greeting_named(inputs)
});
export { today_greeting_named as "today.greeting_named" }